import {ContactRemote} from "@app/core/contact/domain/contact.remote";
import {Contact} from "@app/core/contact/domain/contact";

import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {catchError} from "rxjs/operators";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {Injectable} from "@angular/core";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {Observable} from "rxjs";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";

@Injectable({
    providedIn: 'root'
})
export class ContactWebService implements ContactRemote {

    constructor(
        private baseHandler: EuropastryBaseHandler,
        private credentialsStorage:CredentialsStorage,
        private apiUrls: ApiUrls,
    ) { }

    contact(contact: Contact, deliveryPointCode: number | undefined): Observable<void> {

        const requestBody = {
            telephonePrefix: contact.phonePrefix,
            telephone: contact.phone,
            message: contact.message,
            recaptchaToken: contact.recaptchaToken
        };

        const parameters = new HandlerBuilder()
            .method(HttpMethod.post)
            .authorization(this.credentialsStorage.getCredentials())
            .url(this.apiUrls.CONTACT + deliveryPointCode)
            .body(requestBody)
            .build();

        return this.baseHandler.execute(parameters).pipe(
            catchError(BaseHandleErrorMapper.handleError)
        );
    }
}

